import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useMyDataStore } from 'src/store/me/me.store';
import { useShopkeepersStore } from 'src/store/users/shopkeepers.store';

export default function useShopkeepers() {
  const { getShopkeepersList, isLoadingShopkeepersList, shopkeepersList } = useShopkeepersStore();
  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.usersShopkeepers)

  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'code', label: 'Código' },
    { id: 'cnpj', label: 'CNPJ' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  const normalizeShopkeepers = (list: any) =>
    list.map((shopkeeper: any) => ({
      ...shopkeeper,
      code: shopkeeper.shopkeeperInfo?.code || shopkeeper.managementInfo?.code || 'N/A',
      cnpj: shopkeeper.shopkeeperInfo?.cnpj || 'N/A',
    }));

  const normalizedShopkeepersList = normalizeShopkeepers(shopkeepersList);

  const navigate = useNavigate();

  useEffect(() => {
    getShopkeepersList();
  }, []);

  return {
    isLoadingShopkeepersList,
    shopkeepersList: normalizedShopkeepersList,
    TABLEHEADER,
    permissions,
    navigate,
  };
}
